// import Swiper JS
import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
// import Swiper styles
import 'swiper/swiper.min.css';

const swipers = document.querySelectorAll(".swiper");
swipers.forEach((swiper) => {
    const slides = swiper.querySelectorAll(".swiper-slide");
    new Swiper(swiper, {
        modules: [Navigation],
        slidesPerView: "auto",
        centeredSlides: true,
        loop: slides.length > 3,
        spaceBetween: 16,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
    });
});